import React, { useEffect } from "react";
import Header from "../Section/Header";
import Footer from "../Section/Footer";
import success_gif from "../../Assests/sucess_gif.gif";
import failure_gif from "../../Assests/failure_gif.gif";
import { useLocation, useNavigate } from "react-router-dom";

export default function SuccessPage() {
  const location = useLocation();
  const isSuccessPage = location.pathname === "/success";
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      if (isSuccessPage) {
        navigate("/my-payments");
      } else {
        navigate("/personalized-reading");
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, isSuccessPage]);
  return (
    <div>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-[#1e1e2f] via-[#311744] to-[#1e1e2f] animate-gradient-flow py-12 px-4">
        <div className="max-w-[800px] mx-auto text-white">
          <div className="bg-white/5 backdrop-blur-lg p-10 rounded-2xl border border-purple-600/30 shadow-xl text-base leading-relaxed text-purple-100 space-y-6 flex flex-col justify-center items-center mt-10">
            {/* ✅ Dynamic Image */}
            <div className={isSuccessPage ? "mb-4" : "mb-3"}>
              <img
                src={isSuccessPage ? success_gif : failure_gif}
                alt={isSuccessPage ? "Success" : "Failure"}
                className="h-[130px] w-auto"
              />
            </div>

            {/* ✅ Heading */}
            <h5
              className={`text-[32px] font-bold ${
                isSuccessPage ? "text-green-400" : "text-red-400"
              }`}
            >
              {isSuccessPage ? "Transaction Successful!" : "Transaction Failed"}
            </h5>

            {/* ✅ Detailed Message */}
            <p className="text-center text-purple-200 text-lg leading-7 max-w-2xl">
              {isSuccessPage
                ? `Your transaction has been successfully completed. A confirmation has been sent to your registered email. If you have any questions or need further assistance, please feel free to reach out to our support team. Thank you for trusting us!`
                : `We're sorry! Something went wrong while processing your transaction. This could be due to network issues, invalid payment details, or other technical reasons. Please try again after some time, or contact our support team for immediate help. Your peace of mind is our priority.`}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
